export enum NewsTypes {
	PressRelease = 'press-release',
	News = 'news',
	Newsletter = 'newsletter',
	Media = 'media',
}

export type NewsType =
	| NewsTypes.PressRelease
	| NewsTypes.News
	| NewsTypes.Newsletter;
